module.exports = __webpack_public_path__ + "img/more.e11de37c.svg";